import React, { createContext, useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './SideMenu.css';

// The second, vertical menu: a page's own areas (Gennemgang), services (Konfiguration), frameworks (Compliance) or
// decision types (Beslutninger). It is rendered by the page but lives in a slot of the tenant shell, between the
// main sidebar and the page, so it runs the full height of the window. While one is open the main sidebar folds
// itself in (TenantLayout reads `menuCount`); the user can still unfold it by hand.
export const SideMenuContext = createContext({ slot: null, setMenuCount: () => {} });

// items: [{ key, label, icon, count, tone ('hot' | 'warm'), trail, active, disabled, muted, title, onClick, sepAfter }]
//   disabled — greyed out and not clickable; muted — greyed out but still opens (a service that is not connected)
//   icon  — a ready node (an <svg>), so each page keeps its own drawings
//   count — the red/orange number on the right; trail — any other node there (e.g. a coverage percentage)
// footer: an optional node under the list (the "Forklaring" note)
export default function SideMenu({ title, items, footer }) {
  const { slot, setMenuCount } = useContext(SideMenuContext);
  useEffect(() => {
    setMenuCount((n) => n + 1);
    return () => setMenuCount((n) => n - 1);
  }, [setMenuCount]);
  if (!slot) return null;
  return createPortal(
    <nav className="side-menu" aria-label={title}>
      <h4 className="side-menu__title">{title}</h4>
      {items.map((it) => (
        <React.Fragment key={it.key}>
          <button
            type="button"
            className={`side-menu__link${it.active ? ' is-on' : ''}${it.disabled ? ' is-disabled' : ''}${it.muted ? ' is-muted' : ''}`}
            onClick={it.onClick}
            disabled={it.disabled}
            title={it.title}
            aria-current={it.active ? 'page' : undefined}
          >
            {it.icon && <span className="side-menu__ic">{it.icon}</span>}
            <span className="side-menu__label">{it.label}</span>
            {it.trail}
            {it.count ? <em className={`dv-tab__n${it.tone === 'hot' ? ' is-hot' : it.tone === 'warm' ? ' is-warm' : ''}`}>{it.count}</em> : null}
          </button>
          {it.sepAfter && <div className="side-menu__sep" />}
        </React.Fragment>
      ))}
      {footer && <div className="side-menu__footer">{footer}</div>}
    </nav>,
    slot,
  );
}
